import { DateTime } from "luxon";
import { ServiceReservation } from "../graphql/models";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

export interface ITimeDataResult {
  from: Date;
  to: Date;
  fromString: string;
  toString: string;
  slotString: string;
}

export function useDateTimeUtils() {
  const getTimeData = (record: ServiceReservation): ITimeDataResult => {
    const luxonFrom = DateTime.fromJSDate(new Date(record.date)).toUTC();

    let from = new Date(record.date);
    let fromString = "";
    let to = new Date(record.date);
    let toString = "";
    let slotString = "";
    if (record.slots.length > 0) {
      const [firstSlot, lastSlot] = [
        record.slots[0],
        record.slots[record.slots.length - 1],
      ];
      const duration = lastSlot.toTime - firstSlot.fromTime;
      console.info(`first slot for ${record.code} is ${firstSlot.fromTime}`);
      const hh = Math.trunc(firstSlot.fromTime / 60);
      const mm = firstSlot.fromTime - hh * 60;

      const f = luxonFrom.set({ hour: hh, minute: mm });
      console.info(`final date is ${f.toISO()}`);
      from = f.toJSDate();
      fromString = f.setZone("local").toFormat("HH:mm");
      const toLuxon = f.plus({ minute: duration });
      toString = toLuxon.setZone("local").toFormat("HH:mm");
      to = toLuxon.toJSDate();
      slotString = `${fromString} ➜ ${toString}`;
    }

    return {
      from,
      to,
      fromString,
      toString,
      slotString,
    };
  };

  /**
   * Returns the number of minutes after midnight, or -1 if the hour is not valid
   * @param value
   * @returns
   */
  const checkHourFormat = (value: string) => {
    let result = -1;
    const values = value.split(":");
    if (values.length === 2) {
      const h = values[0];
      const m = values[1];
      if (h.length === 2 && m.length === 2) {
        const _h = parseInt(h);
        const _m = parseInt(m);
        if (isNaN(_h) === false && isNaN(_m) === false) {
          const isValid = _h >= 0 && _h < 24 && _m >= 0 && _m < 60;
          if (isValid) result = _h * 60 + _m;
        }
      }
    }
    return result;
  };

  const checkRange = (from: string, to: string) => {
    const one = checkHourFormat(from);
    const two = checkHourFormat(to);
    if (one !== -1 && two !== -1) return one < two;
    else return false;
  };

  const displayDate = (date: Date | DateTime | string | number) => {
    let dt: DateTime;
    if (date instanceof DateTime) dt = date;
    else if (date instanceof Date) dt = DateTime.fromJSDate(date);
    else if (typeof date === "number") dt = DateTime.fromMillis(date);
    else dt = DateTime.fromISO(date);
    return dt.toLocaleString(DateTime.DATE_SHORT, { locale: "it-IT" });
  };

  const displayDateTime = (date: Date | DateTime | string | number) => {
    let dt: DateTime;
    if (date instanceof DateTime) dt = date;
    else if (date instanceof Date) dt = DateTime.fromJSDate(date);
    else if (typeof date === "number") dt = DateTime.fromMillis(date);
    else dt = DateTime.fromISO(date);
    return dt.toLocaleString(DateTime.DATETIME_SHORT, { locale: "it-IT" });
  };

  const datePickerValueToIsoDate = (value: MaterialUiPickersDate) => {
    let v: string | undefined = undefined;
    if (value) {
      // value is an instance of javascript Date type
      // I want to send to the BE only the Date in ISO
      // toISOString includes also the time and timezone
      // so, I use luxon to create the exact input
      v = DateTime.fromJSDate(value).toISODate() ?? undefined;
    }
    console.debug(`datePickerValueToIsoDate return value is => ${v}`);
    return v;
  };

  const durationDisplayText = (value: number) => {
    if (isNaN(value)) console.warn(`value is not a number! (${value})`);
    const hours = Math.floor(value / 60);
    const minutes = value - hours * 60;
    const minToDisplay = minutes !== 0 ? ` ${minutes}'` : "";
    return `${hours}h${minToDisplay}`;
  };

  return {
    checkHourFormat,
    checkRange,
    getTimeData,
    displayDate,
    displayDateTime,
    datePickerValueToIsoDate,
    durationDisplayText,
  };
}
